import { BaseModel } from "../base.model";
import { StrategyModel } from "../strategy/strategy.model";

export class TaskModel extends BaseModel {
    name?: string;
    type?: 0;
    version?: string;
    lastActive?: string;
    isProcessed?: boolean;
    strategies: StrategyModel[] = [];
}